import ReactDatePicker from "react-datepicker";
import { useCallback, useEffect, useState } from "react";
import EmployeeSelect from "Dashboard/scenes/Resources/components/EmployeeSelect";
import customStyles from "../../Main/components/SelectStyle";
import { DateRange } from "Dashboard/scenes/Carnets/domain/DateRange";
import { BiSearchAlt } from "react-icons/bi";

interface IProps {
  selectDate: (data: DateRange) => void;
  selectedDateFrom: string | undefined;
  selectedDateTo: string | undefined;
  selectEmployee: (employeeId: number) => void;
}

const HtzHeader = (
  { selectDate,
    selectedDateFrom,
    selectedDateTo,
    selectEmployee }: IProps) => {

  const [dateRange, setDateRange] = useState
    <[Date | undefined, Date | undefined]>
    ([selectedDateFrom ? new Date(selectedDateFrom) : undefined,
    selectedDateTo ? new Date(selectedDateTo) : undefined]);
  const [startDate, endDate] = dateRange;

  const selectDateRange = useCallback((dates: Date[]) => {
    const [date0, date1] = dates;
    if (date0 && date1) {
      selectDate({ dateFrom: date0, dateTo: date1 });
    }
    if (!date0 && !date1) {
      selectDate({ dateFrom: undefined, dateTo: undefined });
    }
  }, [selectDate]);

  useEffect(() => {
    selectDateRange(dateRange as Date[]);
  }, [dateRange, selectDateRange]);

  return (
    <div className="row">
      <div className="col start htz-header-cell">
        <label>HTZ</label><label>(redom)</label>
        <div className="employee-select-container">
          <EmployeeSelect
            onChange={selectEmployee}
            customStyles={customStyles}
            placeholder={
              <><BiSearchAlt size={12} /><span>Zaposleni</span></>
            }
          />
        </div>
      </div>
      <div className="col lowercase center separatorLine">datum</div>
      <div className="col lowercase center separatorLine">artikal</div>
      <div className="col strong">
        <div className="dateRange">
          <ReactDatePicker
            selectsRange={true}
            startDate={startDate}
            endDate={endDate}
            showMonthDropdown
            showYearDropdown
            onChange={(update: any) => {
              setDateRange(update);
            }}
            isClearable={true}

          />
        </div>
      </div>
    </div>
  );
};

export default HtzHeader;
